import { AnalyticsContext, ConversionContext } from "@layouts/analytics";
import { Check } from "@piiqtechnologies/svg-icons";
import { PeekSelect, PeekSelectOption, PeekStack, PeekTypography, useTheme } from "@piiqtechnologies/ui-components";
import { useAuthContext } from "@stores/AuthContext";
import React from "react";
const ContextSelector = ({ context, setContext }) => {
    const theme = useTheme();
    const { user } = useAuthContext();
    return (React.createElement(PeekSelect, { "data-testid": "analytics-context-selector", value: context, onChange: (event) => setContext(event.target.value), renderValue: (value) => (React.createElement(PeekTypography, null, value
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "))), inputProps: { "aria-label": "Analytics Context" }, id: "analytics-context-select", MenuProps: {
            disablePortal: true,
            sx: {
                "& .MuiPaper-root": {
                    borderRadius: "8px",
                    width: "162px",
                },
                "& .MuiMenuItem-root": {
                    justifyContent: "space-between !important",
                },
            },
        }, sx: {
            height: "40px",
            fontWeight: "fontWeightMedium",
            ".Mui-selected": {
                backgroundColor: `${theme.palette.common.white} !important`,
                color: `${theme.palette.secondary.main} !important`,
            },
        }, showBorder: true, centerText: true }, Object.values(Object.assign(Object.assign({}, AnalyticsContext), ((user === null || user === void 0 ? void 0 : user.hasSyncCrm) || (user === null || user === void 0 ? void 0 : user.hasSyncPms) ? ConversionContext : {}))).map((item) => (React.createElement(PeekSelectOption, { key: item, value: item },
        React.createElement(PeekStack, { direction: "row", width: "100%", justifyContent: "space-between" },
            React.createElement(PeekTypography, null, item
                .split("-")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ")),
            item === context && React.createElement(Check, { color: theme.palette.secondary.main })))))));
};
export default ContextSelector;
